export default {
  methods: {
    /**
     * Безусловно перемещает, прибавляя переданные значения
     */
    _move(deltas){
      this.transformer.setTranslateX(
        this.transformer.getTranslateX()
        + deltas.x
      );
      this.transformer.setTranslateY(
        this.transformer.getTranslateY()
        + deltas.y
      );
      this.transformer.reTransform(this.$refs.nImg);
    },

    _moveToCenter(){
      this.transformer.setTranslateX(0);
      this.transformer.setTranslateY(0);
      this.transformer.reTransform(this.$refs.nImg);
    },

    /**
     * Вызывается при длительном пинче
     * Если newScale < 1 то возвращает 1
     * @param newScale
     * @returns {*}
     * @private
     */
    _zoom(newScale){

      // не дать зумировать меньше чем на коэфициент 1
      if (newScale < 1) newScale = 1;

      if (newScale > 6) newScale = 6;

      this._correctMoveByZoom(newScale)

      this.transformer.setScaleX(newScale);
      this.transformer.setScaleY(newScale);
      this.transformer.reTransform(this.$refs.nImg);
    },

    _correctMoveByZoom(newScale){
      
      // ХЗ как, но эта функция вроде работает.
      // советую ничего не менять без крайней необходимости.
      let currScale = this._getScale();
      if (newScale >= currScale) return; // чтобы работало только при уменьшении
      
      let currScaleFromZero = currScale - 1;
      let newScaleFromZero = newScale - 1;
      let willZoom = currScaleFromZero - newScaleFromZero; 
      let coeficient = willZoom / currScaleFromZero;  // всегда < 1
      
      // похоже что эти 2 переменные должны называться pxToLeft, но я не уверен
      let pxToRemoveX = coeficient * this.transformer.getTranslateX()
      let pxToRemoveY = coeficient * this.transformer.getTranslateY()
      // console.clear();
      // console.log(`currScale: ${currScaleFromZero}`)
      // console.log(`newScale: ${newScaleFromZero}`)
      // console.log(`coeficient: ${coeficient}`)
      
      this.transformer.setTranslateX(this.transformer.getTranslateX()-pxToRemoveX);
      this.transformer.setTranslateY(this.transformer.getTranslateY()-pxToRemoveY);
      this.transformer.reTransform(this.$refs.nImg);


    },
  }
};


// WEBPACK FOOTER //
// ./src/components/slide-main-rewriters.mixin.js